/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import PromptModal from "../../AdminModel/Components/PromptModal";
import Loader from "../../Components/Loader";
import { RolesContants } from "../../contants";
import { dataActionCreators } from "../../services/Actions";
import { GetUserProfile } from "../../services/Actions/authActions";
import RenderLoanPage from "../RenderLoanPage";
import "./Loan.css";
import FileSaver, * as FileServer from "file-saver";
import { MdOutlineSimCardDownload } from "react-icons/md";
import { Message } from "@material-ui/icons";
import Modal from "../../AdminModel/Components/Modal";
import { sendMessageToMembersBySystemUser } from "../../services/Actions/MessagesAction";

function LoanDetailed() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    MarkedAsBookedAppliedLoans,
    MarkedAsInitiatedAppliedLoans,
    MarkedAsAuthorizedAppliedLoans,
    MarkedAsSubmittedLoan,
    MarkedAsRejectedAppliedLoans,
    RebookLoanByLoanOfficer,
    ResetDataResponse,
    GetLoanDetailed,
    MarkedAsRejectedAppliedLoansByLoanHeads,
  } = bindActionCreators(dataActionCreators, dispatch);
  const data = useSelector((state) => state?.data);
  const user = useSelector((state) => state?.auth);
  // const response = data?.response;
  console.log("location", location);
  const loan_id = location?.state?.loan_id;
  const defaultImage = "/images/dev/avarta2.jpeg";

  console.log("loan_id", loan_id);
  console.log("location", location);

  const [openPromptRejectModal, setPromptOpenRejectModal] = useState(false);
  const [openEditLoanFormModal, setOpenEditLoanFormModal] = useState(false);
  const [openPromptRejectByLoanHeadModal, setPromptOpenRejectByLoanHeadModal] =
    useState(false);
  const [error, setError] = useState("");
  const [rejectMessage, setRejectedMessage] = useState("");
  const [checkedFormEdit, setCheckedFormEdit] = useState(false);
  const [formData, setFormData] = useState("");
  // const [loanDetailed, setLoanDetailed] = useState({})

  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [memberMessage, setMemberMessage] = useState("");
  const [openRebookModal, setOpenRebookModal] = useState(false);
  const [rebookAmountPayable, setRebookAmountPayable] = useState("");
  const [rebookAmountPreviousBalance, setRebookAmountPreviousBalance] =
    useState("");

  const { loan_detailed, response, isLoading } = data;

  let timestamp = new Date().getTime();

  console.log("data", data);
  console.log("user", user);
  // console.log("loanDetailed", loanDetailed);
  console.log("loan_detailed", loan_detailed);

  const handleFormChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
  };

  // useEffect(() => {
  //   setLoanDetailed(loan_detailed);
  // }, [loan_detailed])

  useEffect(() => {
    GetLoanDetailed(loan_id);
    // setLoanDetailed(location?.state?.loan);
  }, [loan_id]);

  const handleImageDownload = (url, name) => {
    // alert("front image download");
    FileServer.saveAs(url, name);
  };
  const handleFormSaveEdited = () => {
    console.log("formData", formData);
  };

  const handleSendMemberMessage = () => {
    try {
      if (memberMessage == "") {
        toast.error("Please message is required");
      } else {
        //
        const payload = {
          message: memberMessage,
          member_staff_id: loan_detailed?.staff_id,
          system_user: "Loan Officer",

          // user_id: auth?.user?._id,

          // user_id: auth?.user?._id,
          // member_profile: auth?.user?.profile_image,
          // reference: "",
        };
        dispatch(sendMessageToMembersBySystemUser(payload));
        setOpen(false);
      }
    } catch (error) { }
  };

  const handleSubmitRebook = () => {
    if (rebookAmountPayable !== "" && rebookAmountPreviousBalance !== "") {
      RebookLoanByLoanOfficer(loan_detailed?._id, {
        rebook_amount_payable: rebookAmountPayable,
        rebook_previous_amount_balance: rebookAmountPreviousBalance,
      });
      setOpenRebookModal(false);
    } else {
      toast.error("Enter for both amount payable and previous balance first");
    }
  };

  useEffect(() => {
    dispatch(GetUserProfile());
  }, []);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetDataResponse();
        history.goBack();
        // history.push('/loans/application')
      }, 1500);
    } else if (response?.state === "UPDATED") {
      toast.success(response?.message);
      GetLoanDetailed(loan_id);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetDataResponse();
        // history.push('')
      }, 1500);
    }
  }, [response?.state]);

  const statusColors = {
    submitted: "bg-yellow-100 text-yellow-800",
    booked: "bg-blue-100 text-blue-800",
    authorized: "bg-purple-100 text-purple-800",
    initiated: "bg-green-100 text-green-800",
    rejected: "bg-red-100 text-red-800",
    paid: "bg-emerald-100 text-emerald-800",
  };

  return (
    <div className="LoanApplicationDetailed">
      <RenderLoanPage title={""}>
        {isLoading && <Loader />}

        {/* Back button */}
        <div className="px-4 pt-4 pb-2">
          <button
            className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-sm font-medium transition-colors"
            onClick={() => history.goBack()}
          >
            <span>&#8592;</span> Back
          </button>
        </div>

        {/* Profile Header Card */}
        <div className="mx-4 mb-6 bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="bg-emerald-700 h-24"></div>
          <div className="px-6 pb-6 -mt-12">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <div className="flex items-end gap-4">
                <div className="image">
                  <img
                    src={
                      loan_detailed?.user?.profile_image
                        ? loan_detailed?.user?.profile_image
                        : ""
                    }
                    alt="profile"
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "50%",
                      border: "4px solid white",
                      objectFit: "cover",
                      background: "#f3f4f6",
                    }}
                  />
                </div>
                <div className="pb-1">
                  <h2 className="text-lg font-bold text-white">{loan_detailed?.user?.name}</h2>
                  <p className="text-sm text-gray-500">{loan_detailed?.user?.staff_id} &middot; {loan_detailed?.user?.facility}</p>
                  {loan_detailed?.status && (
                    <span className={`inline-block mt-1 px-3 py-0.5 rounded-full text-xs font-semibold capitalize ${statusColors[loan_detailed?.status] || "bg-gray-100 text-gray-800"}`}>
                      {loan_detailed?.status}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex flex-wrap gap-2 pb-1">
                <button
                  className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm font-medium transition-colors flex items-center gap-1"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenMessageModal(true);
                  }}
                >
                  <Message style={{ fontSize: "16px" }} /> Message
                </button>
                {loan_detailed?.status === "submitted" && (
                  <button
                    className="px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg text-sm font-medium transition-colors"
                    onClick={() => setOpenRebookModal(true)}
                  >
                    Refinance Loan
                  </button>
                )}
                {loan_detailed?.status === "submitted" && (
                  <button
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors"
                    onClick={() => {
                      if (user?.role.includes(RolesContants.LOAN_OFFICER)) {
                        if (loan_detailed?.status === "booked") {
                          toast.error("Already booked");
                        } else {
                          const body = { status: true };
                          MarkedAsBookedAppliedLoans(loan_detailed?._id, body);
                        }
                      } else {
                        toast.error(`Please you can't perform this operation`);
                      }
                    }}
                  >
                    Book
                  </button>
                )}
                {loan_detailed?.status === "booked" && (
                  <button
                    className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm font-medium transition-colors"
                    onClick={() => {
                      if (user?.role.includes(RolesContants.LOAN_OFFICER_AUTHORIZER)) {
                        const body = { status: true };
                        MarkedAsAuthorizedAppliedLoans(loan_detailed?._id, body);
                      } else {
                        toast.error(`Please you can't perform this operation`);
                      }
                    }}
                  >
                    Authorize
                  </button>
                )}
                {loan_detailed?.status === "authorized" && (
                  <button
                    className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg text-sm font-medium transition-colors"
                    onClick={() => {
                      if (user?.role.includes(RolesContants.LOAN_OFFICER_HEAD)) {
                        const body = { status: true };
                        MarkedAsInitiatedAppliedLoans(loan_detailed?._id, body);
                      } else {
                        toast.error(`Please you can't perform this operation`);
                      }
                    }}
                  >
                    Initiate
                  </button>
                )}
                <button
                  className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg text-sm font-medium transition-colors"
                  onClick={() => {
                    if (user?.role.includes(RolesContants.LOAN_OFFICER_AUTHORIZER)) {
                      setPromptOpenRejectByLoanHeadModal(true);
                    } else if (user?.role.includes(RolesContants.LOAN_OFFICER_HEAD)) {
                      setPromptOpenRejectByLoanHeadModal(true);
                    } else if (user?.role.includes(RolesContants.LOAN_OFFICER)) {
                      setPromptOpenRejectModal(true);
                    }
                  }}
                >
                  Reject
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content - Paired Two Column Grid */}
        <div className="grid gap-6 md:grid-cols-2 px-4 pb-6">

          {/* Row 1: Personal Information (left) */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-3 bg-gray-50 border-b border-gray-100">
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Personal Information</h3>
            </div>
            <div className="p-5 space-y-3">
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Full Name</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.user?.name}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Staff ID</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.user?.staff_id}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Facility</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.user?.facility}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Email Address</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.email}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Phone Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.personal_phone}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Date Of Birth</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.dateOfBirth}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Age</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.age}</span>
              </div>
              <div className="flex justify-between items-start py-2">
                <span className="text-sm text-gray-500">Gender</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.gender}</span>
              </div>
            </div>
          </div>

          {/* Row 1: Address & Contact (right) */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-3 bg-gray-50 border-b border-gray-100">
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Address & Contact</h3>
            </div>
            <div className="p-5 space-y-3">
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Residential Address</span>
                <span className="text-sm font-semibold text-gray-900 text-right">
                  {loan_detailed?.residential_address1}
                  {loan_detailed?.residential_address2 && <>, {loan_detailed?.residential_address2}</>}
                </span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Work Address</span>
                <span className="text-sm font-semibold text-gray-900 text-right">
                  {loan_detailed?.work_address1}
                  {loan_detailed?.work_address2 && <>, {loan_detailed?.work_address2}</>}
                </span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Work Phone</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.work_phone}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">ID Card Type</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.IdCardType}</span>
              </div>
              <div className="flex justify-between items-start py-2">
                <span className="text-sm text-gray-500">ID Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.IDCardNumber}</span>
              </div>
            </div>
          </div>

          {/* Row 2: Guarantor 1 (left) */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-3 bg-gray-50 border-b border-gray-100">
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Guarantor 1</h3>
            </div>
            <div className="p-5 space-y-3">
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Full Name</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_name}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Phone</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_phone}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Staff ID</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_staff_id}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Ghana Card Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_ghana_card}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">GPS Address</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_gps}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Occupation</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_occupation}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Mandate Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_mandate_number}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">OTP Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_otp_number}</span>
              </div>
              <div className="flex justify-between items-start py-2">
                <span className="text-sm text-gray-500">Relationship</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_relationship}</span>
              </div>
            </div>
          </div>

          {/* Row 2: Guarantor 2 (right) */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-3 bg-gray-50 border-b border-gray-100">
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Guarantor 2</h3>
            </div>
            <div className="p-5 space-y-3">
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Full Name</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_name2}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Phone</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_phone2}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Staff ID</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_staff_id2}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Ghana Card Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_ghana_card2}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">GPS Address</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_gps2}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Occupation</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_occupation2}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Mandate Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_mandate_number2}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">OTP Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_otp_number2}</span>
              </div>
              <div className="flex justify-between items-start py-2">
                <span className="text-sm text-gray-500">Relationship</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.guarantor_relationship2}</span>
              </div>
            </div>
          </div>

          {/* Row 3: Loan Details (left) */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-3 bg-gray-50 border-b border-gray-100">
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Loan Details</h3>
            </div>
            <div className="p-5 space-y-3">
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Loan Amount</span>
                <span className="text-lg font-bold  text-gray-700 text-right">{loan_detailed?.loanAmount}</span>
              </div>

              {loan_detailed?.rebook && (
                <div className="bg-green-50 rounded-lg p-3 my-2 border border-green-200">
                  <div className="flex justify-between items-center py-1">
                    <span className="text-sm text-gray-500">Amount Payable</span>
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-bold text-green-700">{loan_detailed?.rebook_amount_payable}</span>
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium text-white bg-gray-500">Refinanced</span>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-1">
                    <span className="text-sm text-gray-500">Previous Balance</span>
                    <span className="text-sm font-semibold text-gray-900">{loan_detailed?.rebook_previous_amount_balance}</span>
                  </div>
                </div>
              )}

              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Loan Term</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.loanTerm}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Monthly Deduction</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.monthlyDeduction}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Initial Amount</span>
                <span className="text-sm font-semibold text-gray-900 text-right">
                  {loan_detailed?.initialAmount && loan_detailed.initialAmount.toFixed(2)}
                </span>
              </div>
              {/* <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Total Collectable</span>
                <span className="text-sm font-semibold text-gray-900 text-right">
                  {loan_detailed?.loantotalCollectable && loan_detailed.loantotalCollectable.toFixed(2)}
                </span>
              </div> */}
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Affordability</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.affordability}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Mandate Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.mandateNumber}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">OTP Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.otpNumber}</span>
              </div>
              <div className="flex justify-between items-start py-2">
                <span className="text-sm text-gray-500">Loan Purpose</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.purposeForLoan}</span>
              </div>
            </div>
          </div>

          {/* Row 3: Bank Information (right) */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-3 bg-gray-50 border-b border-gray-100">
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Bank Information</h3>
            </div>
            <div className="p-5 space-y-3">
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">SSNIT Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.ssnit}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Bank Name</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.bank_name}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Account Holder</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.bank_account_holder_name}</span>
              </div>
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Bank Branch</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.bank_branch}</span>
              </div>
              <div className="flex justify-between items-start py-2">
                <span className="text-sm text-gray-500">Account Number</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.bank_account_number}</span>
              </div>
            </div>
          </div>

          {/* Row 4: Employment (left) */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-3 bg-gray-50 border-b border-gray-100">
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Employment</h3>
            </div>
            <div className="p-5 space-y-3">
              <div className="flex justify-between items-start py-2 border-b border-gray-50">
                <span className="text-sm text-gray-500">Employer Name</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.employer_name}</span>
              </div>
              <div className="flex justify-between items-start py-2">
                <span className="text-sm text-gray-500">Start Date</span>
                <span className="text-sm font-semibold text-gray-900 text-right">{loan_detailed?.employment_start_date}</span>
              </div>
            </div>
          </div>

          {/* Row 4: Ghana Identification Card (right) */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div className="px-5 py-3 bg-gray-50 border-b border-gray-100">
              <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide">Ghana Identification Card</h3>
            </div>
            <div className="p-5">
              <div className="grid grid-cols-2 gap-4">
                <div className="relative group">
                  <div className="rounded-lg overflow-hidden border border-gray-200">
                    <img
                      src={loan_detailed?.frontIDImage}
                      alt="Front ID"
                      style={{ width: "100%", height: "auto", objectFit: "cover" }}
                    />
                  </div>
                  <button
                    className="mt-2 w-full flex items-center justify-center gap-1 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-xs font-medium transition-colors"
                    onClick={() => {
                      FileSaver.saveAs(loan_detailed?.frontIDImage, "front-id.jpg");
                    }}
                  >
                    <MdOutlineSimCardDownload style={{ fontSize: "16px" }} /> Download
                  </button>
                </div>
                <div className="relative group">
                  <div className="rounded-lg overflow-hidden border border-gray-200">
                    <img
                      src={loan_detailed?.passportImage}
                      alt="Passport Photo"
                      style={{ width: "100%", height: "auto", objectFit: "cover" }}
                    />
                  </div>
                  <button
                    className="mt-2 w-full flex items-center justify-center gap-1 px-3 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-xs font-medium transition-colors"
                    onClick={() => {
                      FileSaver.saveAs(loan_detailed?.passportImage, "passport-photo.jpg");
                    }}
                  >
                    <MdOutlineSimCardDownload style={{ fontSize: "16px" }} /> Download
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>

        {openPromptRejectModal && (
          <PromptModal
            closeModal={setPromptOpenRejectModal}
            width={"480px"}
            title="Reject to Member"
          >
            {error && (
              <div className="mx-0 mb-3 px-4 py-2 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-sm text-red-600">{error}</p>
              </div>
            )}
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="reject-message"
                  className="block mb-1.5 text-sm font-medium text-gray-700"
                >
                  Reason for rejection
                </label>
                <textarea
                  id="reject-message"
                  rows="4"
                  onChange={(e) => setRejectedMessage(e.target.value)}
                  className="block w-full px-3 py-2.5 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-200 focus:ring-2 focus:ring-red-200 focus:border-red-400 outline-none transition-all"
                  placeholder="Write the reason for rejecting loan here. The member will see this..."
                ></textarea>
              </div>
              <div className="flex items-center gap-2 px-3 py-2.5 bg-gray-50 rounded-lg border border-gray-200">
                <input
                  id="default-checkbox"
                  type="checkbox"
                  checked={checkedFormEdit}
                  onChange={() => setCheckedFormEdit(!checkedFormEdit)}
                  className="w-4 h-4 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500"
                />
                <label
                  htmlFor="default-checkbox"
                  className="text-sm font-medium text-gray-700"
                >
                  Allow member to <strong>Edit Form</strong>
                </label>
              </div>
              <div className="flex justify-end gap-3 pt-2">
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  onClick={() => setPromptOpenRejectModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={() => {
                    if (rejectMessage === "") {
                      setError("Please add message first");
                      setTimeout(() => { setError(""); }, 5000);
                    } else {
                      const payload = {
                        status: true,
                        message: rejectMessage,
                        resubmit: false,
                        editFormChecked: checkedFormEdit,
                        completed: false,
                      };
                      MarkedAsRejectedAppliedLoans(loan_detailed?._id, payload);
                      setRejectedMessage("");
                      setCheckedFormEdit(false);
                      setPromptOpenRejectModal(false);
                    }
                  }}
                  className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
                >
                  Reject Loan
                </button>
              </div>
            </div>
          </PromptModal>
        )}

        {openPromptRejectByLoanHeadModal && (
          <PromptModal
            closeModal={setPromptOpenRejectByLoanHeadModal}
            width={"480px"}
            title="Reject Loan to Officers"
          >
            {error && (
              <div className="mx-0 mb-3 px-4 py-2 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-sm text-red-600">{error}</p>
              </div>
            )}
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="reject-head-message"
                  className="block mb-1.5 text-sm font-medium text-gray-700"
                >
                  Reason for rejection
                </label>
                <textarea
                  id="reject-head-message"
                  rows="4"
                  onChange={(e) => setRejectedMessage(e.target.value)}
                  className="block w-full px-3 py-2.5 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-200 focus:ring-2 focus:ring-red-200 focus:border-red-400 outline-none transition-all"
                  placeholder="Write the reason for rejecting loan here. The loan officers will see this..."
                ></textarea>
              </div>
              <div className="flex justify-end gap-3 pt-2">
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  onClick={() => setPromptOpenRejectByLoanHeadModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={() => {
                    if (rejectMessage === "") {
                      setError("Please add message first");
                      setTimeout(() => { setError(""); }, 5000);
                    } else {
                      const payload = {
                        status: true,
                        message: rejectMessage,
                        officerRejected: true,
                        rejectedBy: "HEAD",
                        officer: user?.user?.name,
                      };
                      MarkedAsRejectedAppliedLoansByLoanHeads(
                        loan_detailed?._id,
                        payload
                      );
                      setRejectedMessage("");
                      setPromptOpenRejectByLoanHeadModal(false);
                    }
                  }}
                  className="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
                >
                  Reject Loan
                </button>
              </div>
            </div>
          </PromptModal>
        )}

        {openEditLoanFormModal && (
          <PromptModal
            closeModal={setOpenEditLoanFormModal}
            width={"70%"}
            title="Edit Application"
            height={"80vh"}
          >
            <div className="grid gap-6 md:grid-cols-2">
              {/* Left Column - Personal & Guarantor 1 */}
              <div className="space-y-5">
                <div>
                  <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">Personal Information</h4>
                  <div className="space-y-3">
                    <div>
                      <label className="block mb-1 text-xs font-medium text-gray-500">Full Name</label>
                      <input className="w-full px-3 py-2 text-sm bg-gray-100 text-gray-500 rounded-lg border border-gray-200" type="text" readOnly defaultValue={loan_detailed?.user?.name} />
                    </div>
                    <div>
                      <label className="block mb-1 text-xs font-medium text-gray-500">Staff ID</label>
                      <input className="w-full px-3 py-2 text-sm bg-gray-100 text-gray-500 rounded-lg border border-gray-200" type="text" readOnly defaultValue={loan_detailed?.user?.staff_id} />
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Facility</div>
                      <input
                        className="form-control"
                        type="text"
                        readOnly
                        defaultValue={loan_detailed?.user?.facility}
                      />
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Email Address</div>
                      <input
                        className="form-control"
                        type="text"
                        readOnly
                        defaultValue={loan_detailed?.email}
                      />
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Phone Number</div>
                      <input
                        className="form-control"
                        type="text"
                        readOnly
                        defaultValue={loan_detailed?.personal_phone}
                      />
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Date Of Birth</div>
                      <input
                        className="form-control"
                        type="text"
                        readOnly
                        defaultValue={loan_detailed?.dateOfBirth}
                      />
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Age</div>
                      <input
                        className="form-control"
                        type="text"
                        readOnly
                        defaultValue={loan_detailed?.age}
                      />
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Gender</div>
                      <input
                        className="form-control"
                        type="text"
                        name="gender"
                        defaultValue={loan_detailed?.gender}
                        onChange={(e) => handleFormChange(e)}
                      />
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Residential Address 1</div>
                      <div className="value">
                        <input
                          className="form-control"
                          type="text"
                          name="residential_address1"
                          defaultValue={loan_detailed?.residential_address1}
                          onChange={(e) => handleFormChange(e)}
                        />
                        <input
                          className="form-control"
                          type="text"
                          name="residential_address2"
                          defaultValue={loan_detailed?.residential_address2}
                          onChange={(e) => handleFormChange(e)}
                        />
                      </div>
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Work Address</div>
                      <div className="value">
                        <input
                          className="form-control"
                          type="text"
                          name="work_address1"
                          defaultValue={loan_detailed?.work_address1}
                          onChange={(e) => handleFormChange(e)}
                        />
                        <input
                          className="form-control"
                          type="text"
                          name="work_address2"
                          defaultValue={loan_detailed?.work_address2}
                          onChange={(e) => handleFormChange(e)}
                        />
                      </div>
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Work Phone</div>
                      <div className="value">
                        <input
                          className="form-control"
                          type="text"
                          name="work_phone"
                          defaultValue={loan_detailed?.work_phone}
                          onChange={(e) => handleFormChange(e)}
                        />
                      </div>
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">ID Card Type</div>
                      <input
                        className="form-control"
                        type="text"
                        name="IdCardType"
                        defaultValue={loan_detailed?.IdCardType}
                        onChange={(e) => handleFormChange(e)}
                      />

                      {/* <div className="value">{loan_detailed?.IdCardType}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">ID Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="IDCardNumber"
                        defaultValue={loan_detailed?.IDCardNumber}
                        onChange={(e) => handleFormChange(e)}
                      />
                    </div>

                    <hr />
                    <h3>Guarantor 1</h3>

                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Full name</div>
                      <div className="value">
                        <input
                          className="form-control"
                          type="text"
                          name="guarantor_name"
                          defaultValue={loan_detailed?.guarantor_name}
                          onChange={(e) => handleFormChange(e)}
                        />
                        {/* {loan_detailed?.guarantor_name} */}
                      </div>
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Guarantor Phone</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_phone"
                        defaultValue={loan_detailed?.guarantor_phone}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.guarantor_phone}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Guarantor Staff ID</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_staff_id"
                        defaultValue={loan_detailed?.guarantor_staff_id}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.guarantor_staff_id}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Ghana Card Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_staff_id"
                        defaultValue={loan_detailed?.guarantor_ghana_card}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_ghana_card}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Ghana GPS Address</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_gps"
                        defaultValue={loan_detailed?.guarantor_gps}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_gps}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Occupation</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_occupation"
                        defaultValue={loan_detailed?.guarantor_occupation}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_occupation}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Mandate Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_mandate_number"
                        defaultValue={loan_detailed?.guarantor_mandate_number}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_mandate_number}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">OTP Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_otp_number"
                        defaultValue={loan_detailed?.guarantor_otp_number}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_otp_number}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Relationship</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_relationship"
                        defaultValue={loan_detailed?.guarantor_relationship}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_relationship}
              </div> */}
                    </div>
                  </div>

                  <div className="sideTwo">
                    <h3>Guarantor 2</h3>

                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Full name</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_name2"
                        defaultValue={loan_detailed?.guarantor_name2}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_name2}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Guarantor Phone</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_phone2"
                        defaultValue={loan_detailed?.guarantor_phone2}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.guarantor_phone2}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Guarantor Staff ID</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_staff_id2"
                        defaultValue={loan_detailed?.guarantor_staff_id2}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.guarantor_staff_id2}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Ghana Card Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_ghana_card2"
                        defaultValue={loan_detailed?.guarantor_ghana_card2}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_ghana_card2}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Ghana GPS Address</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_gps2"
                        defaultValue={loan_detailed?.guarantor_gps2}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_gps2}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Occupation</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_occupation2"
                        defaultValue={loan_detailed?.guarantor_occupation2}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_occupation2}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Mandate Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_mandate_number2"
                        defaultValue={loan_detailed?.guarantor_mandate_number2}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_mandate_number2}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">OTP Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_otp_number2"
                        defaultValue={loan_detailed?.guarantor_otp_number2}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_otp_number2}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Relationship</div>
                      <input
                        className="form-control"
                        type="text"
                        name="guarantor_relationship2"
                        defaultValue={loan_detailed?.guarantor_relationship2}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">
                {loan_detailed?.guarantor_relationship2}
              </div> */}
                    </div>
                    <hr />
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Loan Amount</div>
                      <input
                        className="form-control"
                        type="text"
                        name="loanAmount"
                        defaultValue={loan_detailed?.loanAmount}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.loanAmount}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Loan Term</div>
                      <input
                        className="form-control"
                        type="text"
                        name="loanTerm"
                        defaultValue={loan_detailed?.loanTerm}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.loanTerm}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Affordability</div>
                      <input
                        className="form-control"
                        type="text"
                        name="affordability"
                        defaultValue={loan_detailed?.affordability}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.affordability}</div> */}
                    </div>

                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Mandate Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="mandateNumber"
                        defaultValue={loan_detailed?.mandateNumber}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.mandateNumber}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">OTP Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="otpNumber"
                        defaultValue={loan_detailed?.otpNumber}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.otpNumber}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Monthly Deduction</div>
                      <input
                        className="form-control"
                        type="text"
                        name="monthlyDeduction"
                        defaultValue={loan_detailed?.monthlyDeduction}
                        onChange={(e) => handleFormChange(e)}
                      />

                      {/* <div className="value">{loan_detailed?.monthlyDeduction}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Loan Purpose</div>
                      <input
                        className="form-control"
                        type="text"
                        name="purposeForLoan"
                        defaultValue={loan_detailed?.purposeForLoan}
                        onChange={(e) => handleFormChange(e)}
                      />

                      {/* <div className="value">{loan_detailed?.purposeForLoan}</div> */}
                    </div>

                    <hr />
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">SNNIT Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="ssnit"
                        defaultValue={loan_detailed?.ssnit}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.ssnit}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Bank Name</div>
                      <input
                        className="form-control"
                        type="text"
                        name="bank_name"
                        defaultValue={loan_detailed?.bank_name}
                        onChange={(e) => handleFormChange(e)}
                        readOnly
                      />
                      {/* <div className="value">{loan_detailed?.bank_name}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Account Holder Name</div>
                      <input
                        className="form-control"
                        type="text"
                        name="bank_account_holder_name"
                        defaultValue={loan_detailed?.bank_account_holder_name}
                        onChange={(e) => handleFormChange(e)}
                        readOnly
                      />
                      {/* <div className="value">
                {loan_detailed?.bank_account_holder_name}
              </div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Bank Branch</div>
                      <input
                        className="form-control"
                        type="text"
                        name="bank_branch"
                        defaultValue={loan_detailed?.bank_branch}
                        onChange={(e) => handleFormChange(e)}
                        readOnly
                      />
                      {/* <div className="value">{loan_detailed?.bank_branch}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Account Number</div>
                      <input
                        className="form-control"
                        type="text"
                        name="bank_account_number"
                        defaultValue={loan_detailed?.bank_account_number}
                        onChange={(e) => handleFormChange(e)}
                        readOnly
                      />
                      {/* <div className="value">{loan_detailed?.bank_account_number}</div> */}
                    </div>
                    <hr />

                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Employer Name</div>
                      <input
                        className="form-control"
                        type="text"
                        name="employer_name"
                        defaultValue={loan_detailed?.employer_name}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.employer_name}</div> */}
                    </div>
                    <div className="item grid  mb-3 md:grid-cols-2">
                      <div className="name">Employee Start Date</div>
                      <input
                        className="form-control"
                        type="date"
                        name="employment_start_date"
                        defaultValue={loan_detailed?.employment_start_date}
                        onChange={(e) => handleFormChange(e)}
                      />
                      {/* <div className="value">{loan_detailed?.employment_start_date}</div> */}
                    </div>

                    {/* <div
              className="item grid  mb-3 md:grid-cols-2"
              style={{
                alignItems: "center",
              }}
            >
              <div>
                <img src={loan_detailed?.frontIDImage+'?'+timestamp} id="frontIDCard" alt="id_front" />
                <div className="passportContainer">
                  <BiCloudDownload
                    className="idDownloadBtn"
                    onClick={() => {
                      handleImageDownload(
                        loan_detailed?.frontIDImage,
                        "image.jpg"
                      );
                    }}
                  />
                </div>
              </div>
              <div>
                <img
                  src={loan_detailed?.passportImage+'?'+timestamp}
                  alt="passport photo"
                  className="passportImage"
                  id="backIDCard"
                />
                <div className="passportContainer">
                  <BiCloudDownload
                    className="passportDownloadBtn"
                    onClick={() => {
                      handleImageDownload(
                        loan_detailed?.passportImage,
                        "image.jpg"
                      );
                    }}
                  />
                </div>
              </div>
            </div> */}
                  </div>
                </div>
                {/* End of form */}

                <button
                  data-modal-toggle="popup-modal"
                  type="button"
                  onClick={() => {
                    // if (rejectMessage === "") {
                    //   setError("Please add message first");
                    //   setTimeout(() => {
                    //     setError("");
                    //   }, 5000);
                    // } else {
                    //   //mark as rejected
                    //   const payload = {
                    //     status: true,
                    //     message: rejectMessage,
                    //     resubmit: false,
                    //     editFormChecked: checkedFormEdit,
                    //     completed: false,
                    //   };
                    //   MarkedAsRejectedAppliedLoans(loan_detailed?._id, payload);
                    //   setRejectedMessage("");
                    //   setCheckedFormEdit(false);
                    //   setPromptOpenRejectModal(false);
                    // }
                  }}
                  className="text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                >
                  Save Changes
                </button>
                <button
                  data-modal-toggle="popup-modal"
                  type="button"
                  className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  onClick={handleFormSaveEdited}
                >
                  No, cancel
                </button>
              </div>
            </div>
          </PromptModal>
        )}

        {openMessageModal && (
          <Modal
            width={"480px"}
            title={"Send Message to Member"}
            closeModal={setOpenMessageModal}
          >
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="member-message"
                  className="block mb-1.5 text-sm font-medium text-gray-700"
                >
                  Message
                </label>
                <textarea
                  id="member-message"
                  rows="4"
                  onChange={(e) => setMemberMessage(e.target.value)}
                  className="block w-full px-3 py-2.5 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-200 focus:ring-2 focus:ring-green-200 focus:border-green-400 outline-none transition-all"
                  placeholder="Write your message here"
                ></textarea>
              </div>
              <div className="flex justify-end gap-3 pt-2">
                <button
                  type="button"
                  onClick={() => setOpenMessageModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={() => handleSendMemberMessage()}
                  className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors"
                >
                  Send Message
                </button>
              </div>
            </div>
          </Modal>
        )}
        {openRebookModal && (
          <Modal
            width={"480px"}
            title={"Refinance Loan"}
            closeModal={setOpenRebookModal}
          >
            <div className="space-y-4">
              <div>
                <label
                  htmlFor="previous_balance"
                  className="block mb-1.5 text-sm font-medium text-gray-700"
                >
                  Previous Loan Balance
                </label>
                <input
                  id="previous_balance"
                  type="number"
                  onChange={(e) =>
                    setRebookAmountPreviousBalance(e.target.value)
                  }
                  className="block w-full px-3 py-2.5 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-200 focus:ring-2 focus:ring-green-200 focus:border-green-400 outline-none transition-all"
                  placeholder="Enter amount"
                />
              </div>
              <div>
                <label
                  htmlFor="amount_payable"
                  className="block mb-1.5 text-sm font-medium text-gray-700"
                >
                  Amount Payable
                </label>
                <input
                  id="amount_payable"
                  type="number"
                  onChange={(e) => setRebookAmountPayable(e.target.value)}
                  className="block w-full px-3 py-2.5 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-200 focus:ring-2 focus:ring-green-200 focus:border-green-400 outline-none transition-all"
                  placeholder="Enter amount"
                />
              </div>
              <div className="flex justify-end gap-3 pt-2">
                <button
                  type="button"
                  onClick={() => setOpenRebookModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={() => handleSubmitRebook()}
                  className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors"
                >
                  Save Amount
                </button>
              </div>
            </div>
          </Modal>
        )}

        <ToastContainer autoClose={3000} />
      </RenderLoanPage>
    </div>
  );
}

export default LoanDetailed;
